export default __webpack_public_path__ + "static/media/midasi_entry_vi_pc.0cd27a63.png";